'use client'

import { TagIcon } from '@heroicons/react/24/solid'

type DiscountListProps = {
  discountNames?: string[]
  variant?: 'checkout' | 'cart'
}

export const DiscountList = ({ discountNames = [], variant = 'checkout' }: DiscountListProps) => {
  if (!discountNames.length) return null

  const isCartVariant = variant === 'cart'

  return (
    <div className="flex flex-col">
      {discountNames.map((discountName, index) => (
        <div
          className={
            isCartVariant
              ? 'prose text-body-sm font-semibold text-bodi-green-deep-500'
              : 'flex gap-1 text-body-xs font-medium text-bodi-gray-medium'
          }
          key={index}
        >
          {!isCartVariant && (
            <TagIcon className="mt-0.5 size-4 shrink-0 -scale-x-100 text-bodi-gray-butters" />
          )}
          <div>{discountName}</div>
        </div>
      ))}
    </div>
  )
}
